<div
  [ngClass]="{'visibility-hidden': hideNavbarBottom}"
  class="navbar-container max-width fixed-bottom d-flex safe-area-bottom"
>
  <nav class="navbar navbar-bottom bg-white flex-fill pr-0">
    <div class="icon-v2 location w-32px" (click)="openGoogleMap()"></div>

    <app-navbar-bottom-icon-explore
      [restaurant]="restaurant"
      [isRestaurant]="true"
    ></app-navbar-bottom-icon-explore>

    <div class="visibility-hidden"></div>
  </nav>

  <app-navbar-bottom-semicircle-notch *ngIf="basket?.isEmpty()">
    <i *ngIf="!searchResult" class="icon main-grey rotate-45"></i>

    <app-navbar-bottom-restaurants-picker
      *ngIf="searchResult"
      [isBasketEmpty]="true"
      [searchResult]="searchResult"
      (restaurantSelected)="onRestaurantsPickerSelected($event)"
    ></app-navbar-bottom-restaurants-picker>
  </app-navbar-bottom-semicircle-notch>

  <nav
    *ngIf="!basket?.isEmpty()"
    class="navbar-main-menu navbar bg-white navbar-bottom px-0 flex-content-vc-hc"
  >
    <i *ngIf="!searchResult" class="icon main-grey"></i>

    <app-navbar-bottom-restaurants-picker
      *ngIf="searchResult"
      [isBasketEmpty]="false"
      [searchResult]="searchResult"
      (restaurantSelected)="onRestaurantsPickerSelected($event)"
    ></app-navbar-bottom-restaurants-picker>
  </nav>

  <nav class="navbar navbar-bottom bg-white flex-fill pl-0">
    <div class="visibility-hidden"></div>

    <div>
      <app-image-picker
        [enableImageSelectModal]="true"
        (save)="onImageUploaded($event)"
        class="w-31px"
      ></app-image-picker>
    </div>

    <div
      class="icon-v2 clock-dark mb-3-5rem mb-3px w-31px"
      (click)="onPreviewModalClick()"
    ></div>
  </nav>
</div>
